/* Copyright 2024 Google LLC
SPDX-License-Identifier: Apache-2.0 */

// How long to wait after the user stops typing until we trigger the AI inference
export const TYPING_DELAY = 800;

export const MODEL_NAME = 'Xenova/toxic-bert';
export const TOXICITY_THRESHOLD = 0.9;
